import React from 'react'

export type CategoryTileProps = {
  title: string
  imageCrops?: {
    url: string
    width: number
  }[]
  recipeCount: number
  onClick: () => void
}

export const getTileKeyDownHandler =
  (onClick: () => void) => (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }
